import Swiper from 'swiper';
import 'swiper/css';
import 'swiper/css/pagination';
import { Navigation, Pagination } from 'swiper/modules';

export default class BannersSlider {
    constructor() {
        this.section = document.querySelector('.component-banners-slider');
        this.slider = this.section.querySelector('.swiper');

        this.ready();
    }

    ready() {
        new Swiper(this.slider, {
            modules: [Navigation, Pagination],
            loop: false,
            grabCursor: true,
            allowTouchMove: true,
            breakpoints: {
                0: {
                    slidesPerView: 1,
                    spaceBetween: 0,
                },
            },
            navigation: {
                nextEl: this.section.querySelector('.slider-button-next'),
                prevEl: this.section.querySelector('.slider-button-prev'),
            },
            pagination: {
                el: this.section.querySelector('.swiper-pagination-nav'),
                clickable: true,
            },
        });
    }
}

if (document.querySelector('.component-banners-slider')) {
    new BannersSlider();
}
